export enum ColchonSize {
  BEBE = 'Bebe 120x140',
  KING = 'King 200x200',
  QUEEN = 'Queen 160x190',
  DOBLE = 'Doble 140x190',
  SEMIDOBLE = 'Semi-doble 120x190',
  SENCILLO = 'Sencillo 90x190',
}
